<!--language: Vue-->
<template>
  <div class="phonePage">
    <el-button class="click" v-if="type == 1 || type == 2" :type="gettype" v-loading.fullscreen.lock="fullscreenLoading"
      @click="changetype(1)">纪念章/大牌</el-button>
    <el-button class="click" v-if="type == 1 || type == 3" :type="gettypeseven" v-loading.fullscreen.lock="fullscreenLoading"
      @click="changetype(2)">来印冰箱贴</el-button>
    <div v-if="gettypeseven == 'success'">
      <sevenData></sevenData>
    </div>
    <div v-if="gettype == 'success'">
      <countData></countData>
    </div>
  </div>

</template>

<script>
import sevenData from './seven.vue'
import countData from './count.vue'
import * as echarts from "echarts";
export default {
  name: "static",
  components: {
    sevenData,
    countData
  },
  data() {
    return {
      // 复选组件
      data: {
        id: 'id',
        value: 'name',
      },
      dataone: {
        id: 'id',
        value: 'name',
      },
      gettype: '',
      gettypeseven: '',
      fullscreenLoading: false,
      typeof: true,
      type: '',
      activeName: this.$store.getters.permissions, // 默认展示的是哪一个权限
    }
  },
  created() {
    console.log('权限', this.activeName);
    if (this.activeName.includes('phone:statistics_CommemorativeMedal') && this.activeName.includes('phone:statistics _refrigeratorstickers')) {
      this.type = 1 // 同时拥有纪念章大牌和777数据
      this.gettype = 'success'
    } else if (this.activeName.includes('phone:statistics_CommemorativeMedal') && !this.activeName.includes('phone:statistics _refrigeratorstickers')) {
      this.type = 2 // 有纪念章大牌数据
      this.gettype = 'success'
    } else if (!this.activeName.includes('phone:statistics_CommemorativeMedal') && this.activeName.includes('phone:statistics _refrigeratorstickers')) {
      this.type = 3 // 有777数据
      this.gettypeseven = 'success'
    }
  },
  mounted() {
  },
  methods: {
    // 切换数据类型
    changetype(val) {
      this.fullscreenLoading = true;
      if (val == 1) {
        this.gettype = 'success'
        this.gettypeseven = ''
        setTimeout(() => {
          this.fullscreenLoading = false;
        }, 2000);
      } else if (val == 2) {
        this.gettype = ''
        this.gettypeseven = 'success'
        setTimeout(() => {
          this.fullscreenLoading = false;
        }, 2000);
      }
    }
  }
}
</script>
<style scoped>
.phonePage {
  margin: 1.5em auto 0 auto;
  /*margin-top: 3.5em;*/
  padding-bottom: 3em;
  box-sizing: border-box;
}

.phonePage .van-tag {
  font-size: 14px;
}
.click{
  margin-top: 2.5em;
  margin-left: 1.5em;
}
</style>
